import React from 'react';
import cn from 'classnames';

export default ({ children, shortCardDesignEnabled, rewriteLook }) => (
  <div className={cn({
    'card-ratio-container': shortCardDesignEnabled,
    'card-ratio-container-tall': !shortCardDesignEnabled,
    'card-ratio-container__rewrite': rewriteLook
  })}>
    <div className="card-ratio-container__inner">
      {children}
    </div>
  </div>
);



// WEBPACK FOOTER //
// ./src/advocate/challenges/components/card_ratio_container.jsx